module.exports = {"654023100":"水定镇","654023101":"清水河镇","654023102":"芦草沟镇","654023103":"惠远镇","654023104":"萨尔布拉克镇","654023200":"兰干乡","654023201":"三道河乡","654023204":"三宫乡","654023205":"大西沟乡","654023402":"果子沟牧场","654023403":"良种繁育中心","654023507":"兵团六十三团","654023508":"兵团六十四团","654023509":"兵团六十六团（中心团场）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654023.json
// module id = 3130
// module chunks = 0